import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { int32_type, option_type, class_type, record_type, string_type, bool_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { list, string, object } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { map, defaultArgWith } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { UTCModule_Parse_iso8601Z, UTC__toDateTime } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { int32ToString, uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { DateTimeExtensions_getAbsoluteMonthDiff, DateTimeExtensions_toDate, logii } from "../../Utils.js";

export class ArgumentBlobValue extends Record {
    constructor(ImpactBounding, Note) {
        super();
        this.ImpactBounding = ImpactBounding;
        this.Note = Note;
    }
}

export function ArgumentBlobValue$reflection() {
    return record_type("Containers.FrozenMonths.Model.ArgumentBlobValue", [], ArgumentBlobValue, () => [["ImpactBounding", bool_type], ["Note", string_type]]);
}

export class FrozenMonth extends Record {
    constructor(FromDate, ToDate, ArgumentBlobValue) {
        super();
        this.FromDate = FromDate;
        this.ToDate = ToDate;
        this.ArgumentBlobValue = ArgumentBlobValue;
    }
}

export function FrozenMonth$reflection() {
    return record_type("Containers.FrozenMonths.Model.FrozenMonth", [], FrozenMonth, () => [["FromDate", class_type("System.DateTime")], ["ToDate", class_type("System.DateTime")], ["ArgumentBlobValue", ArgumentBlobValue$reflection()]]);
}

export function FrozenMonth_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, _arg, arg_6, objectArg_2, msg;
        return new FrozenMonth(defaultArgWith(map(UTC__toDateTime, UTCModule_Parse_iso8601Z((objectArg = get$.Required, objectArg.Field("from_date", string)))), () => {
            throw (new Error("Unable to parse FrozenMonth FromDate"));
        }), defaultArgWith(map(UTC__toDateTime, UTCModule_Parse_iso8601Z((objectArg_1 = get$.Required, objectArg_1.Field("to_date", string)))), () => {
            throw (new Error("Unable to parse FrozenMonth ToDate"));
        }), (_arg = ((arg_6 = ((objectArg_2 = get$.Required, objectArg_2.Field("argument_blob_value", string))), fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(ArgumentBlobValue$reflection(), void 0, void 0)), arg_6))), (_arg.tag === 0) ? _arg.fields[0] : ((msg = _arg.fields[0], (logii(msg), (() => {
            throw (new Error(msg));
        })())))));
    }, path_3, v));
}

export function FrozenMonth_get_ListDecoder() {
    const decoder = FrozenMonth_get_Decoder();
    return (path) => ((value) => list(uncurry(2, decoder), path, value));
}

export class CreateFrozenMonthsDTO extends Record {
    constructor(FromDate, ToDate, Note, ImpactBounding) {
        super();
        this.FromDate = FromDate;
        this.ToDate = ToDate;
        this.Note = Note;
        this.ImpactBounding = ImpactBounding;
    }
}

export function CreateFrozenMonthsDTO$reflection() {
    return record_type("Containers.FrozenMonths.Model.CreateFrozenMonthsDTO", [], CreateFrozenMonthsDTO, () => [["FromDate", string_type], ["ToDate", string_type], ["Note", option_type(string_type)], ["ImpactBounding", bool_type]]);
}

export class UpdateFrozenMonthsDTO extends Record {
    constructor(StartDate, EndDate, Reason, BindingTime) {
        super();
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Reason = Reason;
        this.BindingTime = BindingTime;
    }
}

export function UpdateFrozenMonthsDTO$reflection() {
    return record_type("Containers.FrozenMonths.Model.UpdateFrozenMonthsDTO", [], UpdateFrozenMonthsDTO, () => [["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["Reason", string_type], ["BindingTime", bool_type]]);
}

export class ImpactFee extends Record {
    constructor(FeeNr, InvoicePeriodEnd, StartDate, CancelledDate, EndDate, BoundTo, BilledTo, Description, FeeImpact) {
        super();
        this.FeeNr = (FeeNr | 0);
        this.InvoicePeriodEnd = InvoicePeriodEnd;
        this.StartDate = StartDate;
        this.CancelledDate = CancelledDate;
        this.EndDate = EndDate;
        this.BoundTo = BoundTo;
        this.BilledTo = BilledTo;
        this.Description = Description;
        this.FeeImpact = FeeImpact;
    }
}

export function ImpactFee$reflection() {
    return record_type("Containers.FrozenMonths.Model.ImpactFee", [], ImpactFee, () => [["FeeNr", int32_type], ["InvoicePeriodEnd", class_type("System.DateOnly")], ["StartDate", class_type("System.DateOnly")], ["CancelledDate", option_type(class_type("System.DateOnly"))], ["EndDate", option_type(class_type("System.DateTime"))], ["BoundTo", option_type(class_type("System.DateTime"))], ["BilledTo", option_type(class_type("System.DateOnly"))], ["Description", string_type], ["FeeImpact", bool_type]]);
}

export class EditFrozenMonthRowViewModel extends Record {
    constructor(StartDate, EndDate, ImpactBinding, Reason, Months) {
        super();
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.ImpactBinding = ImpactBinding;
        this.Reason = Reason;
        this.Months = Months;
    }
}

export function EditFrozenMonthRowViewModel$reflection() {
    return record_type("Containers.FrozenMonths.Model.EditFrozenMonthRowViewModel", [], EditFrozenMonthRowViewModel, () => [["StartDate", string_type], ["EndDate", string_type], ["ImpactBinding", string_type], ["Reason", string_type], ["Months", string_type]]);
}

export function convertFrozenMonthToViewModel(getTranslation, locale, fee) {
    return new EditFrozenMonthRowViewModel(DateTimeExtensions_toDate(locale, fee.FromDate), DateTimeExtensions_toDate(locale, fee.ToDate), fee.ArgumentBlobValue.ImpactBounding ? getTranslation("Common.Yes") : getTranslation("Common.No"), fee.ArgumentBlobValue.Note, int32ToString(DateTimeExtensions_getAbsoluteMonthDiff(fee.ToDate, fee.FromDate)));
}

